import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Sidebar from '../../components/Sidebar';
import NewsCard from '../../components/NewsCard';
import { getArticlesByCategory } from '../../firebase/firestore';
import { trackVisit } from '../../utils/trackVisit';
import './CategoryPage.css';

export default function CategoryPage() {
  const { category } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const catName = category.charAt(0).toUpperCase() + category.slice(1);

  useEffect(() => {
    setLoading(true);
    trackVisit({ pageType: 'category', pageURL: `/category/${category}` });
    getArticlesByCategory(catName).then(a => { setArticles(a); setLoading(false); });
  }, [category, catName]);

  return (
    <>
      <Navbar />
      <div className="category-header">
        <div className="container">
          <p className="breadcrumb"><Link to="/">Home</Link> / {catName}</p>
          <h1 className="category-title">{catName}</h1>
          <p className="category-count">{articles.length} article{articles.length !== 1 ? 's' : ''}</p>
        </div>
      </div>
      <main className="container category-main">
        <div className="category-layout">
          <div>
            {loading ? <div className="loading-spinner">Loading...</div>
              : articles.length === 0
                ? <div className="empty-state"><h3>No articles in {catName} yet</h3></div>
                : <div className="category-grid">
                    {articles.map(a => <NewsCard key={a.id} article={a} />)}
                  </div>
            }
          </div>
          <Sidebar />
        </div>
      </main>
      <Footer />
    </>
  );
}
